import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import BtxSwitch from '../../../../Forms/BtxSwitch';
import hasPermission from '../../../../Shared/hasPermission';

const SearchPracticeActivitiesToggle = ({ styles = {} }) => {
    // bool tied to the Search Practice Notes toggle in the text search section
    const searchNotes = useSelector(state => state.practice.searchNotes);

    const dispatch = useDispatch();

    const onChange = useCallback(() => {
        dispatch(actions.practice.setSearchNotes(!searchNotes))
    }, [searchNotes, dispatch]);

    const permissions = useSelector((state) => state.auth.permissions, shallowEqual);
    const can = (permission) => hasPermission(permission, permissions);
    const canSearchActivities = can('SearchActivities');

    if(!canSearchActivities) return [];
    return (
        <BtxSwitch {...styles} onChange={onChange}
            value={searchNotes}
            label='Search Practice Notes'
        />
    );
};

export default SearchPracticeActivitiesToggle;
